import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { isEmpty, pick } from "lodash";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import InternalLoader from "../../component/InternalLoader";
import { t } from "i18next";
import { preventMaxInput } from "../../Utils/constants";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const Affiliate = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState([]);
  const inputRef = useRef(null);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    reset,
  } = useForm({});
  const handle = (e) => {
    if (showPassword.includes(e)) {
      setShowPassword((prev) => {
        return prev?.filter((res) => {
          return res != e;
        });
      });
    } else {
      setShowPassword([...showPassword, e]);
    }
  };
  const onSubmit = async (body) => {
    setLoader(true);
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.affiliate,
        {
          whatsappNumber: body?.mobile,
          username: body?.username,
          password: body?.password,
          confirmPassword: body?.confirmPassword,
          website: hostname || "SABAEXCH",
        }
      );
      if (status === 200) {
        if (response_users.success) {
          toast.success(response_users?.message);
          setLoader(false);
          reset();
        } else {
          toast.error(response_users?.message);
          setLoader(false);
        }
      } else {
        toast.error(response_users?.message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
    }
  };
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="personalCenter">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-index mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span style={{ paddingLeft: "0" }} className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Affiliate</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="am-flexbox am-flexbox-align-middle flex-text">
            <div className="am-flexbox-item">
              <div className="personal-name">
                <span>Create Affiliate</span>
              </div>
            </div>
          </div>
          <div className="account-form n-form-content ">
            <div className="account-form-group  ">
              <div className="false mc-account-list hide-data-svg">
                <svg className="am-icon am-icon-mcNickname_d49ccbbb am-icon-md txt-svg">
                  <use xlinkHref="#mcNickname_d49ccbbb" />
                </svg>
                <input
                  type="text"
                  placeholder="Please enter Username"
                  {...register("username", {
                    required: {
                      value: true,
                      message: "Please enter username",
                    },
                  })}
                />
              </div>
              {errors.username && errors.username.message && (
                <div className="account-errors">
                  <strong> {errors.username.message}</strong>
                </div>
              )}
            </div>{" "}
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-passwordBetter_0bd7a252 am-icon-md txt-svg">
                  <use xlinkHref="#passwordBetter_0bd7a252" />
                </svg>
                <input
                  type={showPassword.includes("new") ? "text" : "password"}
                  className="input-base"
                  placeholder="Please enter password"
                  style={{
                    "-webkit-transition": "0.15s linear",
                    transition: "0.15s linear",
                  }}
                  maxLength={12}
                  minLength={6}
                  {...register("password", {
                    required: "Please enter password",
                    validate: (value) => {
                      if (value === "") {
                        return true;
                      }
                      if (!!value.trim()) {
                        return true;
                      } else {
                        return "White space are not allowed";
                      }
                    },
                  })}
                />{" "}
                <div onClick={() => handle("new")} className="eye-group">
                  <svg
                    className={`am-icon${
                      showPassword.includes("new")
                        ? "am-icon-eyes_27cd1e8b"
                        : "am-icon-eyes-hide_2e21a0e3"
                    } am-icon-md am-icon-eyes`}
                    style={{ color: "rgb(165, 165, 165)" }}
                  >
                    <use
                      xlinkHref={
                        showPassword.includes("new")
                          ? "#eyes_27cd1e8b"
                          : "#eyes-hide_2e21a0e3"
                      }
                    />
                  </svg>
                </div>{" "}
              </div>

              {errors.password && errors.password.message && (
                <div className="am-flexbox am-flexbox-align-middle errors">
                  <div className="am-flexbox-item">
                    <span>{errors.password.message}</span>
                  </div>
                </div>
              )}
            </div>
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-passwordAgain_4b9460bf am-icon-md txt-svg">
                  <use xlinkHref="#passwordAgain_4b9460bf" />
                </svg>
                <input
                  type={
                    showPassword.includes("confirmNew") ? "text" : "password"
                  }
                  className="input-base"
                  placeholder="Confirm new password"
                  style={{
                    "-webkit-transition": "0.15s linear",
                    transition: "0.15s linear",
                  }}
                  maxLength={12}
                  minLength={6}
                  onInput={(e) => preventMaxInput(e)}
                  {...register("confirmPassword", {
                    required: {
                      value: true,
                      message: "Please enter confirm password",
                    },
                    validate: (value) => {
                      if (value === "") {
                        return true;
                      }
                      if (!isEmpty(watch("password"))) {
                        if (value == watch("password")) {
                          return true;
                        } else {
                          return "password and confirm password does not match.";
                        }
                      }
                    },
                  })}
                  onChange={(e) => {
                    setValue("confirmPassword", e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                />{" "}
                <div onClick={() => handle("confirmNew")} className="eye-group">
                  <svg
                    className={`am-icon${
                      showPassword.includes("confirmNew")
                        ? "am-icon-eyes_27cd1e8b"
                        : "am-icon-eyes-hide_2e21a0e3"
                    } am-icon-md am-icon-eyes`}
                    style={{ color: "rgb(165, 165, 165)" }}
                  >
                    <use
                      xlinkHref={
                        showPassword.includes("confirmNew")
                          ? "#eyes_27cd1e8b"
                          : "#eyes-hide_2e21a0e3"
                      }
                    />
                  </svg>
                </div>{" "}
              </div>

              {errors.confirmPassword && errors.confirmPassword.message && (
                <div className="am-flexbox am-flexbox-align-middle errors">
                  <div className="am-flexbox-item">
                    <span>{errors.confirmPassword.message}</span>
                  </div>
                </div>
              )}
            </div>{" "}
            <div className="account-form-group">
              <div className="input-wrap phone-wrap fixed_list">
                <Controller
                  control={control}
                  name="mobile"
                  rules={{
                    required: "Please enter mobile number",
                    validate: (value) => {
                      let inputValue = value
                        ?.toString()
                        ?.slice(
                          inputRef?.current?.state?.selectedCountry?.countryCode
                            ?.length,
                          value?.length
                        );
                      if (inputValue?.length < 10) {
                        return t("MobileMin");
                      } else if (inputValue?.length > 12) {
                        return t("MobileMax");
                      } else {
                        return true;
                      }
                    },
                  }}
                  render={({ field: { ref, ...field } }) => (
                    <>
                      <PhoneInput
                        {...field}
                        inputExtraProps={{
                          ref,
                          required: true,
                          autoFocus: true,
                        }}
                        ref={inputRef}
                        className="inputrefNew"
                        placeholder="Mobile Number"
                        country={"bd"}
                        disableDropdown={true}
                        countryCodeEditable={false}
                      />
                    </>
                  )}
                />
              </div>

              {!isEmpty(errors?.mobile?.message) && (
                <div className="account-errors">
                  <strong> {errors.mobile.message}</strong>
                </div>
              )}
            </div>
            <button
              role="button"
              type="submit"
              style={{ width: "100%" }}
              className="btn-success am-button"
              aria-disabled="false"
            >
              <span>Submit</span>
            </button>
          </div>
        </Form>
      </div>
      {loader && <InternalLoader />}
    </div>
  );
};

export default Affiliate;
